import React, { useState, useEffect } from "react";
import { Box, Paper, Grid, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Button, Stack, IconButton, MenuItem, Dialog, DialogTitle, DialogContent, FormControl, InputLabel, Select, DialogActions, } from '@mui/material';
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { DataGrid } from "@mui/x-data-grid";
import PageLoader from "../../../components/Loader/PageLoader"
import DeleteIcon from '@mui/icons-material/Delete';
import HeaderName from "../../../components/Custom/HeaderName";
import { EditIcon } from "../../../components/Icons";
import { storeEditCustomerDetails } from "../../../redux/Slices/customerSlice";
import Swal from "sweetalert2";
import { deletePickupDetails, getPickupDetails } from "../../../redux/Thunk/officePickupThunk";
import moment from "moment/moment";
import { TextField } from '@mui/material';
import { getCustomerList } from "../../../redux/Thunk/customerThunk";
import FilterListIcon from '@mui/icons-material/FilterList';
import { City, State } from 'country-state-city';

const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
};

const Report = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loader, setLoader] = useState(false)
  const [totalCount, setTotalCount] = useState(0)
  const role = localStorage.getItem('role');
  const [selectedRows, setSelectedRows] = useState([]);
  const [search, setSearch] = useState('');
  const [Report, setReport] = useState([])
  const [createdFrom, setCreatedFrom] = useState('');
  const [createdTo, setCreatedTo] = useState('');
  const [filterOpen, setFilterOpen] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [originCities, setOriginCities] = useState([]);
  const [destinationCities, setDestinationCities] = useState([]);
  const [originStates, setOriginStates] = useState([]);
  const [destinationStates, setDestinationStates] = useState([]);
  const [filters, setFilters] = useState({
    customerName: "",
    originState: "",
    originCity: "",
    destinationState: "",
    destinationCity: "",
    createdFrom: "",
    createdTo: "",
  });
  const debouncedSearch = useDebounce(search, 500);
  const { state } = useLocation();
  const pickup = state?.docketData?.pickupDetails;
  const formattedFrom = createdFrom ? moment(createdFrom).format('YYYY-MM-DD') : '';
  const formattedTo = createdTo ? moment(createdTo).format('YYYY-MM-DD') : '';

  // pagination
  const [page, setPage] = useState({
    page: 0,
    pageSize: 10
  })
  useEffect(() => {
    fetchCustomers();
    fetchStates();
    if (filters.destinationState || filters.originState)
      fetchCities();
  }, [filters.destinationState, filters.originState]);

  const fetchCustomers = async () => {
    dispatch(getCustomerList({ page: page.page + 1, limit: 100 })).then((res) => {
      setCustomers(res?.payload?.data);
    });
  };
  const fetchStates = async () => {
    try {
      const states = State.getStatesOfCountry("IN");
      setOriginStates(states || []);
      setDestinationStates(states || []);
    } catch (error) {
      console.error('Error fetching states:', error);
    }
  };
  const fetchCities = async () => {
    try {
      if (!filters.destinationState && !filters.originState) return;
      const cities = City.getCitiesOfState("IN", filters.destinationState || filters.originState);
      const cityNames = cities.map(city => city.name);
      if (filters.originState && !filters.originCity) {
        setOriginCities(cityNames || []);
      }
      if (filters.destinationState && !filters.destinationCity) {
        setDestinationCities(cityNames || []);
      }
    } catch (error) {
      console.error('Error fetching cities:', error);
    }
  };

  useEffect(() => {
    const handleCSV = async () => {
      try {
        if (!Report || Report.length === 0) return;
        const queryParams = {
          page: 1,
          limit: 10000,
          search: debouncedSearch,
          OfficeId: '',
          isAllocated: '',
          Status: '',
          isExport: "true"
        };

        if (filters.createdFrom) {
          queryParams.createdFrom = moment(filters.createdFrom).format('YYYY-MM-DD');
        }
        if (filters.createdTo) {
          queryParams.createdTo = moment(filters.createdTo).format('YYYY-MM-DD');
        }
        if (filters.customerName) {
          queryParams.CustomerName = filters.customerName;
        }
        if (filters.originCity || filters.destinationCity) {
          queryParams.Destination = filters.destinationCity || filters.originCity;
        }
        if (filters.originState || filters.destinationState) {
          queryParams.OriginState = filters.originState || filters.destinationState;
        }



        dispatch(getPickupDetails(queryParams)).then((res) => {
          if (!res?.payload?.success || !res?.payload?.data?.length) {
            alert('No data available to export');
            return;
          }

          const fullData = res.payload.data; // All rows (e.g., 1080)

          const headers = [
            'Sr. No',
            'Pickup Date',
            'Pickup Time',
            'DocketId',
            'Customer Name',
            'Consignor Name',
            'Consignee Name',
            'Temprature',
            'Data Logger',
            'Packing(Box)',
            'From',
            'From State',
            'To',
            'To State',
            'Boxes',
            'Weight',
            'Reciever Name',
            'Delivery Date & Time',
            'Remark',
            'Status',
          ];

          const csvRows = [];
          csvRows.push(headers.join(','));

          fullData.forEach((row, index) => {
            const get = (val, def = '--') => (val !== undefined && val !== null ? val : def);
            const getNested = (arr, key) =>
              Array.isArray(arr) && arr.length > 0 ? arr[0]?.[key] ?? '--' : '--';

            const formattedRow = [
              index + 1,
              get(row?.PickupDate),
              get(row?.PickupTime),
              get(row?.DocketId),
              getNested(row?.Customers, 'CustomerName'),
              get(row?.Consignee),
              get(row?.Consigner),
              getNested(row?.PackageDetails, 'Temperature'),
              get(row?.DataLoggerValue),
              getNested(row?.PackageDetails, 'Pkg'),
              get(row?.Origin),
              get(row?.OriginState),
              get(row?.Destination),
              get(row?.DestinationState),
              getNested(row?.PackageDetails, 'Pkg'),
              getNested(row?.PackageDetails, 'Volumetrix'),
              get(row?.ReceiverName),
              row?.DeliveryDateAndTime
                ? moment(row.DeliveryDateAndTime).format('D/M/YYYY, h:mm A')
                : '--',
              get(row?.Remark),
              get(row?.Status),
            ];

            const csvLine = formattedRow
              .map((value) =>
                typeof value === 'string'
                  ? `"${value.replace(/"/g, '""')}"`
                  : `"${value}"`
              )
              .join(',');
            csvRows.push(csvLine);
          });

          const bom = '\uFEFF'; // UTF-8 BOM
          const csvContent = bom + csvRows.join('\r\n'); // CRLF line endings

          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `Delivered_Report_${new Date()
            .toLocaleDateString('en-GB')
            .replace(/\//g, '-')}.csv`;
          a.click();
          window.URL.revokeObjectURL(url);
        })
      } catch (error) {
        console.error('❌ CSV Export Error:', error);
        alert('Error generating CSV');
      }
    };

    window.addEventListener('trigger-download-csv', handleCSV);
    return () => window.removeEventListener('trigger-download-csv', handleCSV);
  }, [Report]);


  useEffect(() => {
    fetchPickup()
  }, [page, debouncedSearch, ])

  // get all customer details
  // const fetchPickup = async () => {
  //   setLoader(true);
  //   dispatch(getPickupDetails({
  //     page: page.page + 1,
  //     limit: page.pageSize,
  //     search: debouncedSearch,
  //     OfficeId: '',
  //     isAllocated: '',
  //     Status: 'Delivered'   // ✅ send this to backend
  //   }))
  //   .then((res) => {
  //     const allData = res?.payload?.data || [];
  //     console.log("Delivered from backend:", allData);
  //     setReport(allData);                // already filtered by backend
  //     setTotalCount(allData.length);    // no extra filtering needed
  //     setLoader(false);
  //   });
  // };
  const applyFiltersToData = (data) => {
    return data.filter(row => {
      // Customer Name filter
      if (filters.customerName) {
        const customerName = Array.isArray(row?.Customers) && row.Customers.length > 0
          ? row.Customers[0]?.CustomerName?.toLowerCase().trim()
          : '';
        if (!customerName.includes(filters.customerName.toLowerCase().trim())) return false;
      }

      // City filter (check both Origin and Destination)
      if (filters.originCity || filters.destinationCity) {
        const originCity = row?.Origin?.toLowerCase().trim() || '';
        const destinationCity = row?.Destination?.toLowerCase().trim() || '';
        const originCityFilter = filters.originCity.toLowerCase().trim();
        const destinationCityFilter = filters.destinationCity.toLowerCase().trim();
        if (!originCity.includes(originCityFilter) && !destinationCity.includes(destinationCityFilter)) return false;
      }

      // Date range filter
      if (filters.createdFrom && filters.createdTo) {
        const pickupDate = new Date(row?.PickupDateAndTime);
        const start = new Date(filters.createdFrom);
        const end = new Date(filters.createdTo);
        if (pickupDate < start || pickupDate > end) return false;
      }

      return true;
    });
  };

  const handleFilterChange = (field, value) => {
    setFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const handleApplyFilters = () => {
    fetchPickup();
    setFilterOpen(false);
  };

  const handleClearFilters = () => {
    setFilters({
      customerName: '',
      originCity: '',
      originState: '',
      destinationCity: '',
      destinationState: '',
      createdFrom: '',
      createdTo: ''
    });
    setFilterOpen(false);
  };

  // Filter Popup Component
  const FilterPopup = () => (
    <Dialog open={filterOpen} onClose={() => setFilterOpen(false)} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6">Filter Report</Typography>
      </DialogTitle>

      <DialogContent>
        <Stack spacing={3} sx={{ mt: 2 }}>
          {/* Customer Name Filter */}
          <FormControl fullWidth size="small">
            <InputLabel>Customer Name</InputLabel>
            <Select
              value={filters.customerName}
              label="Customer Name"
              onChange={(e) => handleFilterChange("customerName", e.target.value)}
            >
              <MenuItem value="">All Customers</MenuItem>
              {customers?.length > 0 &&
                customers.map((customer) => (
                  <MenuItem key={customer._id} value={customer.CustomerName}>
                    {customer.CustomerName}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          {/* Origin State Filter */}
          <FormControl fullWidth size="small">
            <InputLabel>Origin State</InputLabel>
            <Select
              value={filters.originState}
              label="Origin State"
              onChange={(e) => handleFilterChange("originState", e.target.value)}
            >
              <MenuItem value="">All Origin States</MenuItem>
              {originStates?.length > 0 &&
                originStates.map((state) => (
                  <MenuItem key={state.isoCode} value={state.isoCode}>
                    {state.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          {/* Origin City Filter */}
          <FormControl fullWidth size="small">
            <InputLabel>Origin City</InputLabel>
            <Select
              value={filters.originCity}
              label="Origin City"
              onChange={(e) => handleFilterChange("originCity", e.target.value)}
            >
              <MenuItem value="">All Origin Cities</MenuItem>
              {originCities?.length > 0 &&
                originCities.map((city) => (
                  <MenuItem key={city} value={city}>
                    {city}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          {/* Destination State Filter */}
          <FormControl fullWidth size="small">
            <InputLabel>Destination State</InputLabel>
            <Select
              value={filters.destinationState}
              label="Destination State"
              onChange={(e) => handleFilterChange("destinationState", e.target.value)}
            >
              <MenuItem value="">All Destination States</MenuItem>
              {destinationStates?.length > 0 &&
                destinationStates.map((state) => (
                  <MenuItem key={state.isoCode} value={state.isoCode}>
                    {state.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          {/* Destination City Filter */}
          <FormControl fullWidth size="small">
            <InputLabel>Destination City</InputLabel>
            <Select
              value={filters.destinationCity}
              label="Destination City"
              onChange={(e) => handleFilterChange("destinationCity", e.target.value)}
            >
              <MenuItem value="">All Destination Cities</MenuItem>
              {destinationCities?.length > 0 &&
                destinationCities.map((city) => (
                  <MenuItem key={city} value={city}>
                    {city}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          {/* Date Range Filters */}
          <TextField
            label="From Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={filters.createdFrom}
            onChange={(e) => handleFilterChange("createdFrom", e.target.value)}
            size="small"
            fullWidth
          />

          <TextField
            label="To Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={filters.createdTo}
            onChange={(e) => handleFilterChange("createdTo", e.target.value)}
            size="small"
            fullWidth
          />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClearFilters} color="secondary">
          Clear Filters
        </Button>
        <Button onClick={() => setFilterOpen(false)} color="primary">
          Cancel
        </Button>
        <Button
          onClick={handleApplyFilters}
          variant="contained"
          sx={{ backgroundColor: "#04AB44" }}
        >
          Apply Filters
        </Button>
      </DialogActions>
    </Dialog>
  );

  const fetchPickup = async () => {
    setLoader(true);
    const queryParams = {
      page: page.page + 1,
      limit: page.pageSize,
      search: debouncedSearch,
      OfficeId: '',
      isAllocated: '',
      Status: '',
    };

    // Add filters to query params if they exist
    if (filters.createdFrom && filters.createdTo) {
      queryParams.createdFrom = moment(filters.createdFrom).format('YYYY-MM-DD');
      queryParams.createdTo = moment(filters.createdTo).format('YYYY-MM-DD');
    }

    if (filters.customerName) {
      queryParams.CustomerName = filters.customerName;
    }
    if (filters.destinationCity) {
      queryParams.Destination = filters.destinationCity;
    }
    if (filters.originCity) {
      queryParams.Origin = filters.originCity;
    }

    dispatch(getPickupDetails(queryParams))
      .then((res) => {
        const allData = res?.payload?.data || [];
        setReport(allData);
        setTotalCount(res?.payload?.total || 0);
        setLoader(false);
      });
  };

  const handleRowSelection = (selection) => {
    if (selection?.length === 0) {
      // If no rows selected, clear the selected rows
      setSelectedRows([]);
    } else {
      // Map the selected IDs to their corresponding rows
      // const selectedRows = selection?.map(selectedId =>
      //   facilityList.find(row => row?._id === selectedId)
      // );
      setSelectedRows(selectedRows);
    }
  };



  const columns = [
    {
      flex: 0.25,
      minWidth: 180,
      field: 'Date & Time',
      align: 'center',
      headerName: 'Pickup Date',
      renderCell: params => {
        const { row } = params
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography
              variant="body2"
              sx={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
                maxWidth: '100%',
                textAlign: 'center',
                flex: 1
              }}
            >
              {moment(row?.PickupDateAndTime).format('D/M/YYYY')}
            </Typography>
          </Box>
        )
      }
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: 'Sr.No',
      align: 'center',
      headerName: 'Sr. No',
      renderCell: params => {
        const { row } = params

        return (
          <Box sx={{ display: 'flex', padding: 1, alignItems: 'center', justifyContent: 'center' }}>
            <Typography noWrap variant='body2' sx={{}}>
              {page?.page * page?.pageSize + params.api.getAllRowIds().indexOf(params.id) + 1}
            </Typography>
          </Box>
        )
      }
    },
    {
      flex: 0.25,
      minWidth: 120,
      field: 'DocketId',
      headerName: 'DocketId',
      align: 'center',
      renderCell: params => {
        const { row } = params

        return (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography noWrap variant='body2'>
              {row?.DocketId}
            </Typography>
          </Box>
        )
      }
    },
    {
      flex: 0.25,
      minWidth: 100,
      field: 'CustomerName',
      headerName: 'Customer Name',
      align: 'center',
      renderHeader: () => (
        <Typography
          variant="subtitle2"
          sx={{
            whiteSpace: 'normal', // ✅ allow wrap
            wordBreak: 'break-word',
            textAlign: 'center',
            lineHeight: 1.2
          }}
        >
          Customer Name
        </Typography>
      ),
      renderCell: params => {
        const { row } = params

        return (
          <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            <Typography
              variant="body2"
              sx={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
                maxWidth: '100%',
                textAlign: 'center',
                flex: 1
              }}
            >              {
                Array.isArray(row?.Customers) && row.Customers.length > 0
                  ? row.Customers[0]?.CustomerName
                  : '--'
              }

            </Typography>
          </Box>
        )
      }
    },
    {
      flex: 0.25,
      minWidth: 100,
      field: 'Consignee',
      headerName: 'Consignor Name',
      align: 'center',
      renderHeader: () => (
        <Typography
          variant="subtitle2"
          sx={{
            whiteSpace: 'normal', // ✅ allow wrap
            wordBreak: 'break-word',
            textAlign: 'center',
            lineHeight: 1.2
          }}
        >
          Consignor Name
        </Typography>
      ),
      renderCell: (params) => {
        const { row } = params;

        return (
          <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            <Typography
              variant="body2"
              sx={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
                maxWidth: '100%',
                textAlign: 'center',
                flex: 1
              }}
            >
              {row?.Consignee || '--'}
            </Typography>
          </Box>
        );
      }

    },
    {
      flex: 0.25,
      minWidth: 100,
      field: 'Consignor',
      headerName: 'Consignee Name',
      align: 'center',
      renderHeader: () => (
        <Typography
          variant="subtitle2"
          sx={{
            whiteSpace: 'normal', // ✅ allow wrap
            wordBreak: 'break-word',
            textAlign: 'center',
            lineHeight: 1.2
          }}
        >
          Consignee Name
        </Typography>
      ),
      renderCell: params => {
        const { row } = params
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            <Typography
              variant="body2"
              sx={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
                maxWidth: '100%',
                textAlign: 'center',
                flex: 1
              }}
            >
              {row?.Consigner || '--'}

            </Typography>
          </Box>
        )
      }
    },
    {
      flex: 0.35,
      minWidth: 100,
      field: "Temparture",
      headerName: 'Temparture',
      align: 'center',
      renderCell: params => {
        const { row } = params

        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{ maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1 }}>
              {
                Array.isArray(row?.PackageDetails) && row.PackageDetails.length > 0
                  ? row.PackageDetails.reduce(
                    (total, pkg) => total + (parseInt(pkg?.Temperature) || 0),
                    0
                  )
                  : '--'
              }
            </Typography>
          </Box>
        )
      }
    },
    {
      flex: 0.35,
      minWidth: 80,
      field: "DataLogger",
      headerName: 'Data Logger',
      align: 'center',
      renderHeader: () => (
        <Typography
          variant="subtitle2"
          sx={{
            whiteSpace: 'normal', // ✅ allow wrap
            wordBreak: 'break-word',
            textAlign: 'center',
            lineHeight: 1.2
          }}
        >
          Data Logger
        </Typography>
      ),
      renderCell: params => {
        const { row } = params

        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{ maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1 }}>
              {row?.DataLoggerValue || '--'}
            </Typography>
          </Box>
        )
      }
    },
    {
      flex: 0.35,
      minWidth: 80,
      field: "Pkg",
      headerName: 'Packing(Box)',
      align: 'center',
      renderHeader: () => (
        <Typography
          variant="subtitle2"
          sx={{
            whiteSpace: 'normal', // ✅ allow wrap
            wordBreak: 'break-word',
            textAlign: 'center',
            lineHeight: 1.2
          }}
        >
          Packing (Box)
        </Typography>
      ),
      renderCell: params => {
        const { row } = params

        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{ maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1 }}>
              {
                Array.isArray(row?.PackageDetails) && row.PackageDetails.length > 0
                  ? row.PackageDetails.reduce(
                    (total, pkg) => total + (parseInt(pkg?.Pkg) || 0),
                    0
                  )
                  : '--'
              }
            </Typography>
          </Box>
        )
      }
    },
    {
      flex: 0.4,
      minWidth: 130,
      field: 'Origin',
      headerName: 'From',
      align: 'center',
      renderCell: params => {
        const { row } = params

        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{ maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1 }}>
              {row?.Origin || '--'}
            </Typography>
          </Box>
        )
      }
    },
    {
      flex: 0.4,
      minWidth: 150,
      field: 'from state',
      headerName: 'From State',
      align: 'center',
      renderCell: params => {
        const { row } = params

        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{ maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1 }}>
              {row?.PickupAddress || '--'}
            </Typography>
          </Box>
        )
      }
    },
    {
      flex: 0.5,
      minWidth: 130,
      field: 'Destination',
      align: 'center',
      headerName: 'To',
      renderCell: params => {
        const { row } = params

        return (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography noWrap variant='body2' sx={{ maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1 }}>
                {row?.Destination || '--'}
              </Typography>
            </Box>
          </>
        )
      }
    },
    {
      flex: 0.5,
      minWidth: 150,
      field: 'To ',
      align: 'center',
      headerName: 'To State',
      renderCell: params => {
        const { row } = params

        return (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography noWrap variant='body2' sx={{ maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1 }}>
                {row?.DestinationAddress || '--'}
              </Typography>
            </Box>
          </>
        )
      }
    },
    {
      flex: 0.5,
      minWidth: 80,
      field: 'Pkges',
      align: 'center',
      headerName: 'Boxes',
      renderCell: params => {
        const { row } = params

        return (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography noWrap variant='body2' sx={{ maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1 }}>
                {
                  Array.isArray(row?.PackageDetails) && row.PackageDetails.length > 0
                    ? row.PackageDetails.reduce(
                      (total, pkg) => total + (parseInt(pkg?.Pkg) || 0),
                      0
                    )
                    : '--'
                }
              </Typography>
            </Box>
          </>
        )
      }
    },
    {
      flex: 0.5,
      minWidth: 90,
      field: 'Volumetrix',
      align: 'center',
      headerName: 'Weight',
      renderCell: params => {
        const { row } = params

        return (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography noWrap variant='body2' sx={{ maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1 }}>
                {
                  Array.isArray(row?.PackageDetails) && row.PackageDetails.length > 0
                    ? row.PackageDetails.reduce(
                      (total, pkg) => total + (parseFloat(pkg?.Volumetrix) || 0),
                      0
                    ).toFixed(2)
                    : '--'
                }

              </Typography>
            </Box>
          </>
        )
      }
    },
    {
      flex: 0.5,
      minWidth: 100,
      field: 'Reciever Name ',
      align: 'center',
      headerName: 'Reciever Name',
      renderHeader: () => (
        <Typography
          variant="subtitle2"
          sx={{
            whiteSpace: 'normal', // ✅ allow wrap
            wordBreak: 'break-word',
            textAlign: 'center',
            lineHeight: 1.2
          }}
        >
          Reciever Name
        </Typography>
      ),
      renderCell: params => {
        const { row } = params

        return (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography
                variant="body2"
                sx={{
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word',
                  maxWidth: '100%',
                  textAlign: 'center',
                  flex: 1
                }}
              >              {row?.ReceiverName || '--'}
              </Typography>
            </Box>
          </>
        )
      }
    },
    {
      flex: 0.25,
      minWidth: 150,
      field: 'Delivery Date & Time',
      align: 'center',
      headerName: 'Delivery Date',
      renderHeader: () => (
        <Typography
          variant="subtitle2"
          sx={{
            whiteSpace: 'normal', // ✅ allow wrap
            wordBreak: 'break-word',
            textAlign: 'center',
            lineHeight: 1.2
          }}
        >
          Delivery Date
        </Typography>
      ),
      renderCell: params => {
        const { row } = params

        return (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography
                variant="body2"
                sx={{
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word',
                  maxWidth: '100%',
                  textAlign: 'center',
                  flex: 1
                }}
              >              {moment(row?.DeliveryDateAndTime).format('D/M/YYYY')}
              </Typography>
            </Box>
          </>
        )
      }
    },
    {
      flex: 0.25,
      minWidth: 130,
      field: 'Remark',
      align: 'center',
      headerName: 'Remark',
      renderCell: params => {
        const { row } = params

        return (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography
                variant="body2"
                sx={{
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word',
                  maxWidth: '100%',
                  textAlign: 'center',
                  flex: 1
                }}
              >              {row?.Remark || ''}
              </Typography>
            </Box>
          </>
        )
      }
    },
    {
      flex: 0.25,
      minWidth: 120,
      field: 'Status',
      align: 'center',
      headerName: 'Status',
      renderCell: params => {
        const { row } = params

        return (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography noWrap variant='body2' sx={{ maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1 }}>
                {row?.Status || ''}
              </Typography>
            </Box>
          </>
        )
      }
    },
    // {
    //   flex: 0.1,
    //   minWidth: 80,
    //   field: 'Action',
    //   headerName: 'Action',
    //   align:'center',
    //   renderCell: params => {
    //     const { row } = params

    //     return (
    //       <Box sx={{ display: 'flex', alignItems: 'center' }}>
    //         <Box sx={{ display: 'flex', alignItems: 'center' }}>
    //           <Typography noWrap variant='body2'>
    //             <IconButton id='edit' onClick={() => row?.Status ==='Delivered' ? '': handleClickEditPickup(row)}><EditIcon w={18} h={18} enabled={row?.Status ==='Delivered' ? false : true}/></IconButton>
    //             <IconButton id='delete' onClick={()=> row?.Status ==='Delivered' ? '': handleClickDeletePickup(row)}><DeleteIcon fontSize="medium" style={{color:row?.Status ==='Delivered' ? '#808080' : '#04AB44'}}/></IconButton>
    //           </Typography>
    //         </Box>
    //       </Box>
    //     )
    //   }
    // },    
  ]

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
        {/* <Header /> */}
        {loader ? <PageLoader /> :
          <Grid container style={{ padding: '0px 10px', width: "60%", display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <HeaderName headerName={'Report'} displaySearch={true} showDownload={true} newForm={false} createNewForm={() => navigate('/dashboard/Report/newpickup')} onClickBackButton={() => navigate("/dashboard")} setSearch={setSearch} search={search} />
              <Stack direction="row" spacing={2} justifyContent="center" alignItems="center" mb={2} mt={-6} ml={50}>
                <Button
                  variant="outlined"
                  startIcon={<FilterListIcon />}
                  onClick={() => setFilterOpen(true)}
                  sx={{
                    textTransform: "none",
                    backgroundColor: "#04AB44",
                    color: "#fff",
                    ":hover": {
                      backgroundColor: "#04AB44",
                    },
                  }}
                >
                  Filters
                </Button>
              </Stack>

              <div className="custom-data-grid-container_table">
                <DataGrid
                  sx={{
                    borderRadius: "31px",
                    overflow: "auto"
                  }}
                  style={{ width: '100%' }}
                  pagination
                  // checkboxSelection
                  rows={Report}
                  rowHeight={55}
                  rowCount={totalCount}
                  getRowId={param => param._id}
                  columns={columns}
                  paginationModel={page}
                  sortingMode='server'
                  paginationMode='server'
                  pageSizeOptions={[10, 50, 100]}
                  onPaginationModelChange={(newPage) => setPage(newPage)}
                  className="custom-data-grid"
                  selectionModel={selectedRows ? [selectedRows] : []}
                  onRowSelectionModelChange={handleRowSelection}
                  initialState={{
                    totalCount,
                    pagination: { paginationModel: { page: 1, pageSize: 10 } },
                  }}
                  disableRowSelectionOnClick
                  disableColumnMenu
                  disableColumnFilter
                  disableColumnSorting
                />
              </div>
            </Grid>
          </Grid>
        }
      </div>
      <FilterPopup />
    </>
  )
}

export default Report